module.exports = __webpack_public_path__ + "static/coronavirus-28d4140b8fb44f19a07288d9b788feee.png";